import axios from '../javascript/custom-axios'
const RESOURCE_NAME = 'innovation'

export default {
  getInnovations(Page= 1, PageSize = 15,Id="") {
    return axios.get(`${RESOURCE_NAME}/GetList`, {
        params: { Page: Page, PageSize: PageSize, GetCurrents: false, Id: Id },
      })
  },
  createInnovation(body){
    return axios.post(`${RESOURCE_NAME}/create`,body)
 
  },
  updateInnovation(body){
    return axios.put(`${RESOURCE_NAME}/update`,body)
 
  },
  getInnovationCriterias(id){
    return axios.get(`${RESOURCE_NAME}/getInovationCrieteria`, {
      params: { inovationId: id },
    })
 
  },
  giveScoreToIdea(body){
    return axios.post(`admin/innovation/giveScore`,body)
 
  },
  getLeaderboard(page,pageSize,id){
    return axios.get(`admin/innovation/getLeaderboard`, {
      params: { page: page, pageSize: pageSize, innovationId: id },
    })
 
  },
}